import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

// Notistack
import { useSnackbar } from 'notistack';

// Material-UI
import { Button, Dialog, DialogContent, DialogActions, Divider } from '@material-ui/core';

// Services
import { deleteContactFromFederationAssociation } from 'services/requests';

// Components
import Spinner from 'components/spinner';

// ---------------------------------------------------------------------------------------------- \\
// ---------------------------------------- DELETE CONTACT -------------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

export default function DeleteContact({ onClose, refetch, contact }) {
    const { enqueueSnackbar } = useSnackbar();
    const { federatedAssociationId } = useParams();
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (loading) {
            deleteContactFromFederationAssociation(federatedAssociationId, contact.id).then(res => {
                if (res.status === 200) {
                    enqueueSnackbar(res.data.message, { variant: 'success' });
                    refetch(contact.id);
                }
                else {
                    enqueueSnackbar(res, { variant: 'error' });
                    setLoading(false);
                }
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loading]);

    return (
        <Dialog open>
            {loading ? (
                <Spinner />
            ) : (
                <>
                    <DialogContent style={{ paddingBottom: 20 }}>
                        <p className="dialog-title">
                            {contact.name}
                        </p>
                        Êtes-vous sûr de vouloir supprimer ce contact ?
                    </DialogContent>
                    <Divider />
                    <DialogActions style={{ justifyContent: 'space-between' }}>
                        <Button onClick={onClose} variant="contained">
                            Non
                        </Button>
                        <Button onClick={() => setLoading(true)} variant="contained">
                            Oui
                        </Button>
                    </DialogActions>
                </>
            )}
        </Dialog>
    );
}
